import api from './api';

// Simple notification service - no complex state management
export const fetchNotifications = async () => {
  try {
    const response = await api.get('/admin/notifications/notifications/');
    return response.data;
  } catch (error) {
    console.error('Error fetching notifications:', error);
    return { results: [], unread_count: 0 };
  }
};

export const markNotificationAsRead = async (notificationId) => {
  try {
    const response = await api.put(`/admin/notifications/notifications/${notificationId}/read/`);
    return response.data;
  } catch (error) {
    console.error('Error marking notification as read:', error);
    return false;
  }
};

export const markAllNotificationsAsRead = async () => {
  try {
    const response = await api.put('/admin/notifications/notifications/mark-all-read/');
    return response.data;
  } catch (error) {
    console.error('Error marking all notifications as read:', error);
    return false;
  }
};

export const deleteNotification = async (notificationId) => {
  try {
    const response = await api.delete(`/admin/notifications/notifications/${notificationId}/`);
    return response.data;
  } catch (error) {
    console.error('Error deleting notification:', error);
    return false;
  }
};

